import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { utcToZonedTime } from 'date-fns-tz';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PriorityEnum, TaskStatusEnum, TaskTypeEnum } from 'src/enumerators';
import { Task, TaskActivitiesProgress } from 'src/models';

@Component({
  selector: 'app-task-card',
  templateUrl: './task-card.component.html',
  styleUrls: ['../../services-page/teams-vehicles/teams-vehicles.component.css', './task-card.component.css'],
})
export class TaskCardComponent implements OnInit {
  modalRef: BsModalRef;

  loading = true;
  @Input() card: Task = undefined;
  @Input() taskActivitiesList: Array<TaskActivitiesProgress> = [];
  @Input() waitingForEdition: boolean = false;
  @Input() signsLength: number = 0;
  @Input() disabled: boolean = false;
  @Output() emitEvent = new EventEmitter<{
    signalingType;
    type: 'open' | 'remove' | 'edit';
    id: string;
    taskType?: TaskType;
  }>();

  taskActivities: TaskActivitiesProgress;
  taskActivitiesProgress: Array<boolean> = [];
  priorityEnum = PriorityEnum;
  taskTypeEnum = TaskTypeEnum;
  taskStatusEnum = TaskStatusEnum;
  currentId;

  ngIconClass: Object;

  constructor(private _modalService: BsModalService) { }

  ngOnInit(): void {

    this.ngIconClass = {
      'fa-square-plus': this.card.taskType == this.taskTypeEnum.Implantation,
      'fa-square-x': this.card.taskType == this.taskTypeEnum.Removal,
      'fa-brush': this.card.taskType == this.taskTypeEnum.Maintenance,
      'fa-arrow-down-to-bracket': this.card.taskType == this.taskTypeEnum.Cataloging,
      'fa-arrows-cross': this.card.taskType == this.taskTypeEnum.Replacement,
    };

    const executionDate = utcToZonedTime(this.card.executionDate, 'UTC');
    this.card.executionDate = executionDate;

    this.taskActivities = this.taskActivitiesList.find((task) => task.taskId == this.card.id);
    for (let index = 0; index < this.taskActivities?.activities; index++) {
      this.taskActivitiesProgress.push(index < this.taskActivities?.completedActivities);
    }
    this.loading = false;
  }

  handleEmitEvent(signalingType, type: 'open' | 'remove' | 'edit', id?: string, taskType?: TaskType): void {
    if (!this.disabled) this.emitEvent.emit({ id, type, signalingType, taskType });
  }

  // abre modal
  openModal(template: TemplateRef<any>): void {
    this.modalRef = this._modalService.show(template, {
      class: 'modal-dialog-centered modal-lg',
      backdrop: 'static',
    });
  }
}
